'use client';

import { DividendPerShareValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: DividendPerShareValues;
  onValuesChange: (field: keyof DividendPerShareValues, value: number | string) => void;
  translations: ToolsTranslations['dividendPerShare'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const parseNumber = (value: string) => {
    const normalized = value.replace(/\s/g, '').replace(',', '.');
    const num = parseFloat(normalized);
    return isNaN(num) ? null : num;
  };

  return (
    <div className="space-y-6">
      {/* Total dividend */}
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <label htmlFor="total-dividend" className="text-gray-700 font-medium">{translations.totalDividend}</label>
          <div className="flex items-center gap-2">
            <input
              id="total-dividend"
              type="text"
              value={new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(values.totalDividend)}
              onChange={(e) => {
                const num = parseNumber(e.target.value);
                if (num !== null && num >= 0) onValuesChange('totalDividend', num);
              }}
              className="w-48 text-right border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 px-3 py-2 text-gray-800 font-semibold bg-white shadow-sm"
              aria-label={translations.totalDividend}
            />
            <span className="text-gray-800 font-semibold">{values.currency}</span>
          </div>
        </div>
      </div>

      {/* Shares outstanding */}
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <label htmlFor="shares-outstanding" className="text-gray-700 font-medium">{translations.sharesOutstanding}</label>
          <div className="flex items-center gap-2">
            <input
              id="shares-outstanding"
              type="text"
              value={new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(values.sharesOutstanding)}
              onChange={(e) => {
                const num = parseNumber(e.target.value);
                if (num !== null && num >= 0) onValuesChange('sharesOutstanding', num);
              }}
              className="w-48 text-right border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 px-3 py-2 text-gray-800 font-semibold bg-white shadow-sm"
              aria-label={translations.sharesOutstanding}
            />
          </div>
        </div>
      </div>
    </div>
  );
}


